import { render } from "./SearchFullItemSkeleton.vue?vue&type=template&id=2462bf86&scoped=true"
import script from "./SearchFullItemSkeleton.vue?vue&type=script&lang=js"
export * from "./SearchFullItemSkeleton.vue?vue&type=script&lang=js"

import "./SearchFullItemSkeleton.vue?vue&type=style&index=0&id=2462bf86&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2462bf86"]])

export default __exports__